/* eslint-disable no-debugger */
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import CustomerSatisfaction from '@usas/ui-web/components/payments/components/inputs/CustomerSatisfaction';
import { formatDate } from '@usas/ui-web/utils/DateFunctions';

import useCustomerSatisfactionItem from './UseCustomerSatisfactionItem';

import lpstyle from './../../LandingPages.module.css';

const CustomerSatisfactionItem = ({ customerSatisfactionItem }) => {
  const { state, onClick } = useCustomerSatisfactionItem(customerSatisfactionItem);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '30px', paddingRight: '30px', paddingBottom: '10px' }}>
        <span style={{ flex: 1 }}>
          Your interaction with <b>{customerSatisfactionItem.firstName} {customerSatisfactionItem.lastName}</b> on <b>{formatDate(customerSatisfactionItem.touchpointDate)}</b>
        </span>
        {state.showSurvey === false &&
          <ActionIntraPageButton onClick={onClick} className={lpstyle.ActionButton}>
            {state.label}
          </ActionIntraPageButton>
        }
      </div>
      {state.showSurvey === true &&
        <div style={{ paddingLeft: '90px', paddingBottom: '20px' }}>
          <CustomerSatisfaction
            count={5}
            iconSize={40}
            defaultRating={0}
            icon={''}
            dataKeyName={customerSatisfactionItem.touchpointFieldName}
            dataKeyValue={customerSatisfactionItem.touchpointId}
            customerSatisfactionId={customerSatisfactionItem.customerSatisfactionId}
            helpText={`How satisfied were you with your interaction with your USA Swimming advisor?<br/>
How would you rate your recent engagement?`}
          />
        </div>
      }
    </div>
  );
};

export default CustomerSatisfactionItem;